var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { COMPONENT_STRINGS } from "../../constants";
import logoPernambuco from "../../assets/logo-pernambuco-full.png";
export var Footer = function () {
    var FOOTER = COMPONENT_STRINGS.FOOTER;
    return (_jsx("footer", __assign({ className: "w-full bg-[#0034B7] text-white pt-10 pb-8 px-4 sm:px-6 lg:px-8 mt-auto" }, { children: _jsxs("div", __assign({ className: "container mx-auto" }, { children: [_jsx("div", __assign({ className: "flex justify-end items-center mb-8" }, { children: _jsx("div", __assign({ className: "flex items-center" }, { children: _jsx("img", { src: logoPernambuco, alt: "Governo de Pernambuco", className: "h-12 w-auto object-contain brightness-0 invert" }) })) })), _jsx("div", { className: "w-full h-px bg-white/30 my-6" }), _jsxs("div", __assign({ className: "flex flex-col md:flex-row justify-between gap-4 text-xs opacity-80 font-light" }, { children: [_jsx("span", { children: FOOTER.COPYRIGHT }), _jsx("div", __assign({ className: "flex gap-4" }, { children: _jsx("span", { children: "Procon Pernambuco \u2014 Todos os direitos reservados." }) }))] }))] })) })));
};
